import { createWebHashHistory , createRouter } from "vue-router";
import Coupon from './components/Coupon.vue'

const routes = [
  {
    path: "/coupon/:id",
    component: Coupon,
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router; 